import React, { useState } from "react";
import CustomInput from "../../../Core/Components/CustomInput";
import CloseIcon from "../../../Common/Svgs/CloseIcon";
import FilterItem from "../../../Core/Components/FilterItem";
import ChevronIcon from "../../../Common/Svgs/ChevronIcon";
import { statusFilters } from "./constants";

const Header = ({
  showKpi,
  setShowKpi,
  search,
  setSearch,
  filters,
  setFilters,
  setCurrentPage,
}) => {
  const [focus, setFocus] = useState(false);

  const onSelect = (key, value) => {
    // whenever applying the filter, the page should be defaulted back to first page
    setCurrentPage(1);

    if (filters[key].includes(value)) {
      const newFilters = filters[key].filter((item) => item !== value);
      setFilters({ ...filters, [key]: newFilters });
    } else {
      setFilters({ ...filters, [key]: [...filters[key], value] });
    }
  };

  return (
    <div className="bg-background-white px-6 py-2.5 border-y-[0.5px] border-light-grey flex items-center justify-between">
      <div className="flex items-center gap-x-2">
        <CustomInput
          intent="search"
          prefix={
            <img src="/assets/icons/search.svg" alt="" className="mr-2" />
          }
          value={search}
          focus={focus}
          border={focus ? "success" : "none"}
          placeholder={focus ? null : "Search Assets"}
          onChange={(e) => setSearch(e.target.value)}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          suffix={
            search.length > 0 ? (
              <CloseIcon
                className="w-4 h-4 cursor-pointer stroke-dark-grey-text"
                onClick={() => {
                  setFocus(false);
                  setSearch("");
                }}
              />
            ) : null
          }
        />

        <FilterItem
          label="Status"
          identifier="status"
          contentData={statusFilters}
          onSelect={onSelect}
          customValue
          selectedValues={filters.status}
          className="max-h-[200px] overflow-y-scroll"
        />
      </div>

      <div className="flex items-center gap-x-3">
        <button
          type="button"
          className="flex items-center justify-center w-8 h-6 rounded-md bg-[#eeeeee]"
          onClick={() => setShowKpi(!showKpi)}
        >
          <ChevronIcon
            className={`w-4 h-4 stroke-black ${
              showKpi ? "rotate-90" : "-rotate-90"
            }`}
          />
        </button>
      </div>
    </div>
  );
};

export default Header;
